import { useState } from 'react';
import { Formik, Field, Form, ErrorMessage } from 'formik';
import * as Yup from 'yup';
import Swal from 'sweetalert2';
import emailjs from '@emailjs/browser';

import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Button from 'react-bootstrap/esm/Button';

import LinkedIn from "../../assets/icons/LinkedIn.png";
import Instagram from "../../assets/icons/Instagram.png";
import TikTok from "../../assets/icons/TikTok.png";

import './Contact.css';

const styles = {
    error: {
        textAlign: "left",
        color: "white",
        fontStyle: "italic",
        fontWeight: "bold",
    },
};

const validationSchema = Yup.object().shape({
    first_name: Yup.string().required(<span style={styles.error}>Numele este obligatoriu</span>),
    class: Yup.string().required(<span style={styles.error}>Nivelul este obligatoriu</span>),
    email: Yup.string()
        .email(<span style={styles.error}>Adresa de email este invalidă</span>)
        .required(<span style={styles.error}>Adresa de email este obligatorie</span>),
    message: Yup.string().required(<span style={styles.error}>Mesajul este obligatoriu</span>),
});

export default function Contact() {
    const [isFormSubmitted, setIsFormSubmitted] = useState(false);

    const sendEmail = (values) => {
        const templateParams = {
            user_name: values.first_name,
            user_email: values.email,
            user_phone: values.phone,
            user_class: values.class,
            message: values.message,
        };

        emailjs
            .send('service_aew514f', 'template_o21xcg4', templateParams, 'wgJFpA_4E1G_XA6V-')
            .then((result) => {
                console.log('Email trimis:', result.text);
                setIsFormSubmitted(true);
                Swal.fire({
                    icon: "success",
                    title: "Mesajul a fost trimis cu succes!",
                    showConfirmButton: false,
                    timer: 3000
                });
            })
            .catch((error) => {
                console.error('Eroare la trimitere:', error.text);
                Swal.fire({
                    icon: "error",
                    title: "A apărut o eroare!",
                    text: "Te rugăm să încerci din nou mai târziu.",
                });
            });
    };

    return (
        <Container className="contactContainer worldwide">
            <p className="contactTitle">
                <span className="bracket">{'<'}</span>
                    Contact
                <span className="bracket">{'/>'}</span>
            </p>
            <p className="contactSubTitle">
                Contactează-mă dacă ai o întrebare sau chiar și dacă vrei să colaborăm
            </p>
            <Row>
                <Col lg={4} className="text-center2">
                    <p className="contactFormTitle">Descriere:</p>
                    <p className="contactFormText">
                        Pentru pregătiri, întrebări sau colaborări, mă poți contacta fără ezitări prin mail sau formular.
                    </p>
                    <hr/>
                    <p className="contactFormTitle">Telefon:</p>
                    <a href="tel:+40751938757" className="contactFormEmail">
                        0751 938 757
                    </a>
                    <hr/>
                    <p className="contactFormTitle">Email:</p>
                    <a href="mailto:antoniocrantea@gmail.com" className="contactFormEmail">
                        antoniocrantea@gmail.com
                    </a>
                    <hr/>
                    <p className="contactFormTitle">Rețele de socializare:</p>
                    <a href="https://www.linkedin.com/in/antonio-crantea/" target="blank">
                        <img src={LinkedIn} className="contactIcons" alt="LinkedIn" />
                    </a>{' '}
                    <a href="https://www.tiktok.com/@info_cu_toni" target="blank">
                        <img src={TikTok} className="contactIcons" alt="TikTok" />
                    </a>{' '}
                    <a href="https://www.instagram.com/info_cu_toni/" target="blank">
                        <img src={Instagram} className="contactIcons" alt="Instagram" />
                    </a>
                    <hr/>
                </Col>
                <Col lg={8} className="text-center">
                    <Formik
                        initialValues={{
                            first_name: '',
                            class: '',
                            email: '',
                            phone: '',
                            message: '',
                        }}
                        validationSchema={validationSchema}
                        onSubmit={(values, { setSubmitting, resetForm }) => {
                            sendEmail(values);
                            resetForm();
                            setSubmitting(false);
                        }}
                    >
                        {({ isSubmitting }) => (
                            <Form className="contactContainer" style={{marginTop: "-75px"}}>
                                <Row>
                                    <Col lg={7}>
                                        <Field
                                            type="text"
                                            name="first_name"
                                            className="form-control formAppearance formText"
                                            placeholder="Nume și prenume"
                                        />
                                        <ErrorMessage name="first_name" component="div" className="error-message"/>
                                    </Col>
                                    <Col lg={5}>
                                        <Field
                                            as="select"
                                            name="class"
                                            className="form-control formAppearance formText"
                                        >
                                            <option value="">Nivelul</option>
                                            <option value="gimnaziu">Clasele V-VIII</option>
                                            <option value="9">Clasa a IX-a</option>
                                            <option value="10">Clasa a X-a</option>
                                            <option value="11">Clasa a XI-a</option>
                                            <option value="12">Clasa a XII-a</option>
                                            <option value="facultate">Facultate</option>
                                            <option value="profesor">Profesor</option>
                                            <option value="parinte">Părinte</option>
                                            <option value="altceva">Altceva</option>
                                        </Field>
                                        <ErrorMessage name="class" component="div" className="error-message"/>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col lg={7}>
                                        <Field
                                            type="email"
                                            name="email"
                                            className="form-control formAppearance formText"
                                            placeholder="Email"
                                        />
                                        <ErrorMessage name="email" component="div" className="error-message"/>
                                    </Col>

                                    <Col lg={5}>
                                        <Field
                                            type="text"
                                            name="phone"
                                            className="form-control formAppearance formText"
                                            placeholder="Telefon (opțional)"
                                        />
                                    </Col>
                                </Row>
                                <Row>
                                    <Col lg={12}>
                                        <Field
                                            as="textarea"
                                            name="message"
                                            className="textarea form-control formAppearance formText"
                                            placeholder="Scrie mesajul aici..."
                                            rows="8"
                                        />
                                        <ErrorMessage name="message" component="div" className="error-message"/>
                                    </Col>
                                </Row>
                                <Row className="text-center">
                                    <div className="buttonContainer mt-4 w-100">
                                        <Button
                                            variant="dark"
                                            type="submit"
                                            className="d-flex align-items-center justify-content-center contactButton w-100"
                                            disabled={isSubmitting || isFormSubmitted}
                                        >
                                            {isFormSubmitted ? 'Trimis' : 'Trimite'}
                                        </Button>
                                    </div>
                                </Row>
                            </Form>
                        )}
                    </Formik>
                </Col>
            </Row>
        </Container>
    );
}